import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Subscription } from 'rxjs';

import { CasesService } from '../../../services/cases.service';
import { HelpService } from '../../../services/help.service';
import { UserConfigs } from '../../../models/user-configs.model';
import { UserConfigsService } from '../../../services/user-configs.service';
import { EmailThreadGrouping } from '../../../models/email-thread-grouping.model';
import { EmailThreadSummary } from '../../../models/email-thread-summary.model';
import { LexbeCase } from '../../../models/case.model';

@Component({
    selector: 'lex-email-thread-groupings',
    templateUrl: './email-thread-groupings.component.html',
    styleUrls: ['./email-thread-groupings.component.scss'],
    standalone: false
})
export class EmailThreadGroupingsComponent implements OnInit, OnDestroy, AfterViewInit {

  threadGroupings: EmailThreadGrouping[] = [];
  emailThreadBrowseLink: string = '/review/browse?EmailThreadId=';
  currentCase: LexbeCase;
  totalEmailThreads: number;
  pageSize: number = 20;
  pageSizeOptions: number[] = [20, 40, 60, 80, 100];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  private subscription = new Subscription();

  constructor(private userService: UserConfigsService, private casesService: CasesService, private helpService: HelpService) { }

  ngOnInit() {
    this.subscription.add(this.userService.getUserConfigs()
      .subscribe((configs: UserConfigs) => {
        this.currentCase = configs.currentCase;

        this.casesService.getEmailThreadSummary(this.currentCase.caseId)
          .subscribe((summary: EmailThreadSummary) => {
            this.totalEmailThreads = summary.threadGroupingCount;
          });

        this.casesService.getEmailThreadGroupings(this.currentCase.caseId, 0, this.pageSize)
          .subscribe((groups: EmailThreadGrouping[]) => {
            this.threadGroupings = groups;
          });
      }));

    this.helpService.updateHelpLink("browse-menu/email-thread-groups");
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngAfterViewInit() {
    this.paginator.page.subscribe((event: PageEvent) => {
      this.getEmailThreadGroupings(event);
    });
  }

  private getEmailThreadGroupings($event: PageEvent) {
    this.casesService.getEmailThreadGroupings(this.currentCase.caseId, $event.pageIndex, $event.pageSize)
      .subscribe((groups: EmailThreadGrouping[]) => {
        this.threadGroupings = groups;
      });
  }

}
